/**
 * Shared "smooth" pill for the time-series charts — an opt-in N-day moving
 * average toggle (the smoothing itself is `rollingMean` in salience/format.ts).
 * Both the salience ShareTrendChart and the home cross-signal chart use this so
 * the control looks and reads identically across the portal.
 */
export function SmoothToggle({
  smooth,
  onToggle,
  windowDays = 7,
  className = "",
}: {
  smooth: boolean;
  onToggle: () => void;
  windowDays?: number;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={smooth}
      title={`${windowDays}-day moving average — smooths spiky daily values into a trend line`}
      className={`flex items-center gap-1.5 rounded px-2 py-0.5 text-[11px] transition-colors ${
        smooth
          ? "bg-terminal-elevated text-terminal-ink"
          : "text-terminal-ink-muted hover:text-terminal-ink"
      } ${className}`}
    >
      <span className="text-[10px]" aria-hidden>
        ∿
      </span>
      Smooth {windowDays}d
    </button>
  );
}
